import request from "./request";

// 活动
export function getActivity() {
  return request(
    {
      url: "/cczhweb/content/index",
      method: "get",
      // isToken: true,
    }
  );
}


// 协议
export function agreementList(data) {
  return request(
    {
      url: "/cczhweb/sys/agreement",
      method: "post",
      data,
    }
  );
}


// 域名后缀(二级)
export function getWhois(params) {
  return request({
    url: "/cczhweb/domain/domainWhoisInfo",
    method: "get",
    params
  });
}
//Whois查询
export function getCaptchaWhoisV1(domain) {
  return request({
    url: `/cczhweb/sys/captcha/whois/${domain}`,
    method: "get",
  });
}

//Whois查询
export function getCaptchaWhoisV2(domain, id, vCode) {
  return request({
    url: `/cczhweb/sys/captcha/whois/${domain}/${id}/${vCode}`,
    method: "get",
  });
}

// 域名后缀(二级)
export function getDomainSuffix() {
  return request({
    url: "/cczhweb/domain/domainSuf",
    method: "get",
  });
}

// 获取敏感词
export function sensitiveWords() {
  return request(
    {
      url: "/cczhweb/domain/sensitiveWords",
      method: "post",
    },
    false
  );
}

// 域名注册查询
export function searchDomain(data) {
  return request(
    {
      url: "/cczhweb/domain/examine",
      method: "post",
      data,
    },
    true
  );
}

//域名价格
export function getPriceList(type) {
  return request(
    {
      url: "/cczhweb/domain/domainPriceList/" + type,
      method: "get",
    },
    false
  );
}

//加入购物车
export function addShopCart(data) {
  return request({
    url: "/cczhweb/shoppingTrolley/create",
    data,
    method: "post",
    isToken: true,
  });
}

// 查询模板
export function getTemplates(params) {
  return request({
    url: "/cczhweb/domain/templates/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 购物车查询
export function getShoppingCart(params) {
  return request({
    url: "/cczhweb/shoppingTrolley",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改年限
export function orderCountEdit(data) {
  return request({
    url: "/cczhweb/shoppingTrolley/count/edit",
    data,
    method: "post",
    isToken: true,
  });
}

// 购物车删除
export function delectShopCart(data) {
  return request({
    url: "/cczhweb/shoppingTrolley/delete",
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 模板删除
export function delectTemplates(templateId) {
  return request({
    url: `/cczhweb/domain/templates/delete/${templateId}`,
    method: "DELETE",
    isToken: true,
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/cczhweb/shoppingTrolley/order",
    data,
    method: "post",
    isToken: true,
  });
}

// 支付订单
export function pay(data) {
  return request({
    url: "/cczhweb/pay",
    data,
    method: "post",
    isToken: true,
  });
}

// 获取支付订单
export function orderPayOrder(params) {
  return request({
    url: "/cczhweb/order/payOrder",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名查询条件
export function domainQuery() {
  return request({
    url: "/cczhweb/domain/domainQuery",
    method: "get",
    isToken: true,
  });
}

// 域名品类
export function domainTypeList() {
  return request({
    url: "/cczhweb/domain/typeList",
    method: "get",
    isToken: true,
  });
}

// 我的域名
export function domainList(params) {
  return request({
    url: "/cczhweb/domain/domainList",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板
export function templatesList(params) {
  return request({
    url: "/cczhweb/domain/templates/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板-根据模板查看域名列表
export function templatesDomainList(params) {
  return request({
    url: "/cczhweb/domain/templates/domain/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 删除模板
export function deleteTemplate(params) {
  return request({
    method: "delete",
    url: `/cczhweb/domain/templates/delete/${params}`,
    isToken: true,
  });
}

// 复制模板
export function getTemplateCopy(params) {
  return request({
    url: "/cczhweb/domain/templates/copy",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取邮箱，企业，个人认证
export function getcertifiedInformation() {
  return request({
    url: "/cczhweb/prove/certifiedInformation",
    method: "get",
    isToken: true,
  });
}

// 获取中国地区城市
export function getRegionList() {
  return request({
    url: "/cczhweb/user/region/list",
    method: "get",
    isToken: true,
  });
}

// 查询默认模板
export function getTemplatesDefault() {
  return request({
    url: "/cczhweb/domain/templates/default/detail",
    method: "get",
    isToken: true,
  });
}

// 提交模板
export function templatesSave(data) {
  return request({
    url: "/cczhweb/domain/templates/create",
    data, // post
    method: "post",
    isToken: true,
  });
}

// 提交默认模板
export function templatesDefaultSave(data) {
  return request({
    url: "/cczhweb/domain/templates/default/save",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 模板过户
export function templatesTransfer(data) {
  return request({
    url: "/cczhweb/domain/templates/transfer",
    data,
    method: "post",
    isToken: true,
  });
}

// 模板过户记录
export function getTemplatesTransferList(params) {
  return request({
    url: "/cczhweb/domain/templates/transfer/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出记录
export function getTransferOutList(params) {
  return request({
    url: "/cczhweb/domain/transferOut/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-重新索取转移码
export function transferOutRefreshCode(params) {
  return request({
    url: "/cczhweb/domain/transferOut/refreshCode",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-取消转出
export function transferOutCancel(params) {
  return request({
    url: "/cczhweb/domain/transferOut/cancel",
    params,
    method: "DELETE",
    isToken: true,
  });
}

// 转出-同意转出
export function transferOutConsent(params) {
  return request({
    url: "/cczhweb/domain/transferOut/consent",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferOutQueryStatus(params) {
  return request({
    url: "/cczhweb/domain/transferOut/queryStatus",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入记录
export function transferIntoList(params) {
  return request({
    url: "/cczhweb/domain/transferInto/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入-修改转移码
export function transferIntoEdit(data) {
  return request({
    url: "/cczhweb/domain/transferInto/transferCode/edit",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferIntoDetail(params) {
  return request({
    url: "/cczhweb/domain/transferInto/status/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测域名
export function transferOutCheckDomain(params) {
  return request({
    url: "/cczhweb/domain/transferOut/checkDomain",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测手机
export function transferOutCheckMobile(data) {
  return request({
    url: "/cczhweb/domain/transferOut/checkMobile",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-获取转移码
export function transferOutTransferCode(data) {
  return request({
    url: "/cczhweb/domain/transferOut/getTransferCode",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 转入-检测手机
export function transferIntoSave(data) {
  return request({
    url: "/cczhweb/domain/transferInto/save",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-检测用户是否存在
export function userCheck(params) {
  return request({
    url: "/cczhweb/user/check",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH
export function pushCreate(data) {
  return request({
    url: "/cczhweb/domain/push/create",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-分页查询
export function pushPageList(params) {
  return request({
    url: "/cczhweb/domain/push/pageList",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH-操作
export function pushEdit(data) {
  return request({
    url: "/cczhweb/domain/push/edit",
    data,
    method: "post",
    isToken: true,
  });
}

// 域名订单列表
export function orderPageList(params) {
  return request({
    url: "/cczhweb/order/pageList",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名订单-取消订单
export function orderCancel(data) {
  return request({
    url: "/cczhweb/order/cancel",
    params: data,
    method: "post",
    isToken: true,
  });
}

// 域名订单-订单详情
export function orderDetail(params) {
  return request({
    url: "/cczhweb/order/orderDetail",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置隐私保护
export function domainSetPrivacy(data) {
  return request({
    url: `/cczhweb/domain/privacyProtection/update`,
    data,
    method: "post",
    isToken: true,
  });
}

// 我的域名-自动续费
export function domainAutoRenew(data) {
  return request({
    url: `/cczhweb/domain/autoRenew`,
    data,
    method: "post",
    isToken: true,
  });
}

// 例行维护公告
export function serverUpdate() {
  return request(
    {
      url: "/cczhweb/content/serverUpdate",
      method: "post",
      isToken: true,
    }
  );
}
